/**
 * iter150AZ.77 — pure-function helpers extracted from MeasurementCapture
 * so unit tests can import them without dragging in axios / WS / SW
 * dependencies. Both helpers are re-exported from MeasurementCapture.jsx
 * for backwards compatibility with all existing callers.
 */

/** Build a `slot` key matching the backend's schema. */
export function slotKey(kind, state, phase) {
  return `${kind}:${state}:${phase}`;
}


/** Returns true when every required voltage / amps slot for the
 *  configured phase count has been captured.
 *
 *  A slot counts as captured when EITHER:
 *    • The server-side record exists with ``final_value != null`` AND
 *      ``approved === true`` (the AI / manual-override path).
 *    • The local stub has ``_offline === true`` — the photo is queued
 *      in the SW outbox; AI runs server-side after sync. Without this
 *      branch the wizard's Continue gate is impossible to satisfy
 *      when the tech is on-site without signal.
 */
export function isMeasurementsSetComplete(items, phaseCount, ampsRequired = true) {
  if (!Array.isArray(items)) return false;
  const haveSlot = (k, s, p) =>
    items.some(i => i.slot === slotKey(k, s, p)
                  && (i._offline === true
                      || (i.final_value != null && i.approved === true)));
  if (phaseCount === 1) {
    if (!haveSlot("voltage", "running", "single")) return false;
    if (!haveSlot("voltage", "stopped", "single")) return false;
    if (ampsRequired && !haveSlot("amps", "running", "single")) return false;
    return true;
  }
  for (const ph of ["l1_l2", "l2_l3", "l1_l3"]) {
    if (!haveSlot("voltage", "running", ph)) return false;
    if (!haveSlot("voltage", "stopped", ph)) return false;
  }
  if (ampsRequired) {
    for (const ph of ["l1", "l2", "l3"]) {
      if (!haveSlot("amps", "running", ph)) return false;
    }
  }
  return true;
}
